var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const inchesToPixels = (inches) => Math.floor(parseFloat(inches.replace("in", "")) * 96);
const sizeToPixels = (size) => {
  let isPercentage = false;
  if (typeof size === "string") {
    if (size.includes("%")) {
      size = parseFloat(size.replace("%", ""));
      isPercentage = true;
    } else if (size.includes("in")) {
      size = inchesToPixels(size);
    } else if (size.endsWith("px")) {
      size = parseFloat(size.replace("px", ""));
    }
  }
  return [size, isPercentage];
};
class Position {
  constructor(x, y, {
    width,
    height,
    xOffset,
    yOffset,
    minWidth,
    minHeight,
    maxWidth,
    maxHeight
  } = {}) {
    __publicField(this, "x");
    __publicField(this, "y");
    __publicField(this, "xOffset", 0);
    __publicField(this, "xOffsetPercentage", false);
    __publicField(this, "yOffset", 0);
    __publicField(this, "yOffsetPercentage", false);
    __publicField(this, "width", 0);
    __publicField(this, "widthPercentage", false);
    __publicField(this, "height", 0);
    __publicField(this, "heightPercentage", false);
    __publicField(this, "minWidth", 0);
    __publicField(this, "minWidthPercentage", false);
    __publicField(this, "minHeight", 0);
    __publicField(this, "minHeightPercentage", false);
    __publicField(this, "maxWidth", 0);
    __publicField(this, "maxWidthPercentage", false);
    __publicField(this, "maxHeight", 0);
    __publicField(this, "maxHeightPercentage", false);
    this.x = x;
    this.y = y;
    [this.width, this.widthPercentage] = sizeToPixels(width || this.width);
    [this.height, this.heightPercentage] = sizeToPixels(height || this.height);
    [this.minWidth, this.minWidthPercentage] = sizeToPixels(minWidth || this.minWidth);
    [this.minHeight, this.minHeightPercentage] = sizeToPixels(minHeight || this.minHeight);
    [this.maxWidth, this.maxWidthPercentage] = sizeToPixels(maxWidth || this.maxWidth);
    [this.maxHeight, this.maxHeightPercentage] = sizeToPixels(maxHeight || this.maxHeight);
    [this.xOffset, this.xOffsetPercentage] = sizeToPixels(xOffset || this.xOffset);
    [this.yOffset, this.yOffsetPercentage] = sizeToPixels(yOffset || this.yOffset);
  }
}
const isRectangle = (rect) => {
  if (rect.left !== void 0) {
    return true;
  }
  return false;
};
class Rectangle {
  constructor(left, top, width, height) {
    __publicField(this, "left");
    __publicField(this, "top");
    __publicField(this, "width");
    __publicField(this, "height");
    __publicField(this, "right");
    __publicField(this, "bottom");
    __publicField(this, "x");
    __publicField(this, "y");
    __publicField(this, "justify");
    __publicField(this, "align");
    if (typeof left === "object") {
      this.set(left.x, left.y, left.width, left.height);
    } else {
      this.set(left, top, width, height);
    }
  }
  set(left, top, width, height) {
    this.x = left;
    this.y = top;
    this.left = left;
    this.top = top;
    this.width = width || this.width;
    this.height = height || this.height;
    this.right = this.left + this.width;
    this.bottom = this.top + this.height;
  }
  toPosition() {
    let x = this.x / 1920 * 100;
    let y = this.y / 1080 * 100;
    return new Position(this.justify || x, this.align || y, { width: this.width, height: this.height });
  }
}
export {
  Position,
  Rectangle,
  isRectangle
};
//# sourceMappingURL=Rectangle.js.map
